import request from '@/utils/request';

export async function queryPortletTypes() {
  return request('/portlets/types');
}

export async function queryPortals() {
  return request('/portals');
}

export async function queryPortlets() {
  return request('/portlets');
}

export async function queryPortalsPortlets() {
  return request('/portals/portlets');
}

export async function savePortlets({ method, params }) {
  return request('/portlets', {
    method,
    body: params,
  });
}

export async function bindPortlets({ portalId, menuId, params }) {
  if (portalId) {
    return request(`/portals/${portalId}/portlets`, {
      method: 'POST',
      body: params,
    });
  }
  return request(`/menus/${menuId}/portlets`, {
    method: 'POST',
    body: params,
  });
}

export async function queryMenus () {
  return request('/menus/D');
}
